<template>
  <div class="col nav-302 d-print-none">
    <div class="justify-content-center align-items-center py-1 text-center row">

      <div class="text-right col-4 order-1 col-lg-1">

      </div>


      <div class="order-9 order-lg-1 order-sm-9 order-md-9 col-8 col-lg-3 p-0 m-0 my-sm-2">
        <div class="mx-auto ">
          <m-search-input1 class="nav302-search"/>
        </div>
      </div>

      <div class="col-lg-3 order-1 col-4">
        <m-a :href="{name:'Home'}">
          <m-img class="nav-302-logo" :src="findAttributeOnSiteInfo('icon')[0]"
                 :alt="findAttributeOnSiteInfo('site_name')[0]"/>
        </m-a>
      </div>


      <div class="order-1 col-4 col-lg-3 d-lg-none ">

      </div>

      <hr class="d-lg-none w-100 order-7 "/>


      <div class="order-9 order-lg-1 order-sm-9 order-md-9 col-4 col-lg-4">

        <m-a class="text-dark nav-302-icon h3" :href="{name:'Home'}">
          <i class="bi bi-house my-auto"/>
        </m-a>

        <m-a class="text-dark nav-302-icon h3" v-if="hideDashboardLink" :href="dashboardLink">
          <i class="bi bi-person my-auto"/>
        </m-a>

        <!-- shopping cart -->
        <m-a class="text-dark nav-302-icon h3" v-if="IsAuthenticated || findAttributeOnSiteInfo('cartType') == 1"
             :href="{ name: 'ShoppingCart' }">
          <i class="my-auto bi bi-cart "/>
          <span class="badge badge-warning shopping-cart-counter "
                v-if=" orderCount.length != 0 && orderCount.items != undefined">{{ orderCount.items.length }} </span>
        </m-a>
        <m-a v-else class="text-dark nav-302-icon h3" :href="{ name: 'UnAuthenticatedShoppingCart' }">
          <i class="my-auto bi bi-cart "/>
          <span class="badge badge-warning shopping-cart-counter ">{{ shoppingCartCount }} </span>
        </m-a>
        <!-- shopping cart -->

      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import mA from '../../Tags/A'
import mImg from '../../Tags/Img'
import mSearchInput1 from "../../Search/Input/SearchInput1";

export default {
  name: "Nav302",
  props: {
    hideDashboardLink: {
      type: Boolean,
      default: true
    },
    dashboardLink: {
      default: 'https://mixitweb.com'
    }
  },
  components: {mA, mImg, mSearchInput1},
  data() {
    return {
      shoppingCartCount: 0
    }
  },
  computed: {
    ...mapGetters({
      isAuth: "User/isAuthenticated",
      storeMenus: "Menu/getAllMenus",
      orderCount: 'ShoppingCart/getSidebarBasketData',
    }),
    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    },
  },
  methods: {
    countItemsOnUnAuthenticatedShoppingCart() {
      const localProducts = localStorage.products;
      this.shoppingCartCount = localProducts != undefined ? Object.keys(JSON.parse(localStorage.products)).length : 0;
    }
  },
  async mounted() {
    if (this.IsAuthenticated) {
      await this.$store.dispatch("ShoppingCart/userOrderUnpaid");
    }
    window.addEventListener('click', this.countItemsOnUnAuthenticatedShoppingCart);
  }
}
</script>

<style>

.nav302-search .search-input-1-input {
  padding: 5px;
  text-align: center;
}


.nav302-search form {
  background-color: white;
  padding: 3px;
}

.nav302-search input::placeholder {
  text-align: center;
}

.nav302-search input:focus-visible {
  outline: none;
}

</style>

<style scoped>
.nav-302-logo {
  width: 90px;
  height: auto;
}


.nav-302-icon {
  margin-right: 3px;
}

.shopping-cart-counter {
  font-size: 12px;
  margin: 16px -14px 0 0;
  position: absolute;
}

@media (max-width: 400px) {
  .nav-302-icon {
    font-size: 22px;
  }

}

</style>